<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="users.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="user"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :user="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="users && users.per_page"
        layout="total, prev, pager, next"
        :total="users && users.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../TableSettings';
import columns, { allColumns, labels } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['user/paginatedUsers'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['user/tableConfig']));
    },
    loading() {
      return this.$store.getters['user/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    await this.$store.dispatch('user/fetchAllWithPagination');
  },

  methods: {
    handleCurrentChange(val) {
      this.$store.commit('user/setCurrentPage', val);
      this.$store.dispatch('user/fetchAllWithPagination');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('user/setSorting', { prop, order});
        this.$store.dispatch('user/fetchAllWithPagination');
      }
    },
  },
};
</script>
